/**
 * Política de força de senha — mesma regra do cadastro (registerSchema).
 */

export type PasswordStrength = 'weak' | 'medium' | 'strong';

export const PASSWORD_REQUIREMENTS = [
  'Pelo menos 8 caracteres',
  'Pelo menos uma letra maiúscula',
  'Pelo menos um número',
] as const;

export function isStrongPassword(password: string): boolean {
  if (!password || password.length < 8) return false;
  if (!/[A-Z]/.test(password)) return false;
  if (!/[0-9]/.test(password)) return false;
  return true;
}

/** Mesma heurística visual do RegisterForm. */
export function evaluatePasswordStrength(password: string): PasswordStrength {
  if (!password || password.length < 8) return 'weak';
  if (password.length < 12 || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
    return 'medium';
  }
  return 'strong';
}

export function passwordRequirementChecks(password: string) {
  return {
    minLength: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
  };
}
